import { createReducer } from '@reduxjs/toolkit'
import { PartnerT } from 'shared/types/model'
import { receivePartner, clear } from 'model/actions'

const initialState = null as PartnerT | null

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receivePartner, (_state, action) => action.payload)
    .addCase(clear, () => initialState)
})

export default reducer
